import { Token } from "@/utils/custom-utl-sdk/types"
import { atom } from "jotai"

export const allTokenInfosAtom = atom<Token[]>([])
